import { Alert, Card, CardBody, Col } from "reactstrap";
import { AdditionalAlertTitle } from "../../../constants";
import { AdditionalAlertData, AdditionalAlertSubTitle } from "../../../data/uiKits/Alert";
import CommonCardHeader from "../../../coreComponents/CommonCardHeader";

const AdditionalAlert = () => {
  return (
    <Col sm="12">
      <Card>
        <CommonCardHeader title={AdditionalAlertTitle} span={AdditionalAlertSubTitle} />
        <CardBody className="dark-alert">
          {AdditionalAlertData &&
            AdditionalAlertData.map((item, index) => (
              <Alert color="transparent" className={`bg-light-${item.class}`} key={index}>
                <h3 className={`pb-2 txt-${item.class}`}>{item.head}</h3>
                <p>{item.text}</p>
                <hr />
                <p className="mb-0">{item.subtext}</p>
              </Alert>
            ))}
        </CardBody>
      </Card>
    </Col>
  );
};
export default AdditionalAlert;
